import { RouterProvider } from 'react-router';
import { SWRConfig } from 'swr';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { SessionExpireProvider } from './pages/sessionExpiredHandle/SessionExpireContext';
import GeoLocationGuard from 'utils/route-guard/GeoLocationGuard';
import { swrFetcher } from './hooks/useSWRFetcher';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

import { useEffect } from 'react';
import { preloadBigLogos } from './services/logoService';

export default function App() {
  useEffect(() => {
    // Preload only big logos on mount (login/registration pages need these)
    preloadBigLogos();
  }, []);

  return (
    <SWRConfig
      value={{
        fetcher: swrFetcher,
        revalidateOnFocus: false, // Auto-refresh when user switches back to tab
        revalidateOnReconnect: false,
        shouldRetryOnError: false, // Retry on network errors
        errorRetryCount: 0, // Max 3 retries
        onError: (err) => {
          console.error('Global SWR Error:', err);
        }
      }}
    >
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <AuthProvider>
                <GeoLocationGuard>
                  <SessionExpireProvider>
                    <Notistack>
                      <RouterProvider router={router} />
                      <Snackbar />
                    </Notistack>
                  </SessionExpireProvider>
                </GeoLocationGuard>
              </AuthProvider>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </SWRConfig>
  );
}
